import { render, staticRenderFns } from "./ItemTypeSelect.vue?vue&type=template&id=02704679&lang=pug"
import script from "./ItemTypeSelect.vue?vue&type=script&lang=js"
export * from "./ItemTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports